$(document).ready(function()
{
    $(".js-slick").slick({
        dots: true,
        autoplay: true,
        autoplaySpeed: 6000
    });

    $(".js-slick-testimonials").slick({
        dots: true,
        autoplay: true,
        autoplaySpeed: 6000,
        adaptiveHeight: true
    });

    $(".reveal-modal").on("opened", function() {
        alert( 'heloo' );
        $(".js-slick-testimonials").slick('setPosition');
    });



    $(".js-card-slider").slick({
        dots: true,
        arrows: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $(".js-background-video").each(function()
    {
        var playerContainer = $(this);

        if($(this).hasClass('youtube'))
        {
            $(this).YTPlayer({
                videoId: $(this).data('video-id'),
                playerVars: {
                    playlist: $(this).data('video-id'),
                    loop: 1
                },
                fitToBackground: false,
                width: 	$(this).width(),
                callback: function() {
                    $(playerContainer).addClass('js-remove-background')
                }
            });
        };

    });


    $(".js-logo-slider").each(function () {
        // Some settings
        var slides = $(this).find('.slide').length;
        var slides_to_show = 3;
        var slides_to_scroll = 1;

        // If there are aload of items we increase the amounts visible
        if( slides >= 6 ) {
            slides_to_show = 6;
            slides_to_scroll = 2;
        }

        if( slides <= 3 ) {
            $( this ).removeClass( 'js-logo-slider' );
            return;
        }

        $(this).slick({
            autoplay: true,
            autoplaySpeed: 2000,
            dots: false,
            arrows: true,
            infinite: true,
            touchThreshold: 10,
            slidesToShow: slides_to_show,
            slidesToScroll: slides_to_scroll,
            adaptiveHeight: false,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });

    })



    $( '.js-video-background' ).each(function () {
        
    });

});